import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * RoleProtectedRoute
 * @param {Object} user - current logged in user object
 * @param {Array} allowedRoles - roles that can access this route
 */
const RoleProtectedRoute = ({ user, allowedRoles = [], permission, action = 'view', children }) => {
  if (!user) {
    return <Navigate to="/" replace />; // Not logged in
  }

  const normalizedRole = String(user.role || '').toLowerCase().replaceAll(' ', '_');
  const normalizedAllowedRoles = allowedRoles.map((role) => String(role).toLowerCase().replaceAll(' ', '_'));
  const roleAllowed = permission ? true : (!allowedRoles.length || normalizedAllowedRoles.includes(normalizedRole));
  const permissionAllowed = !permission || user?.permissions?.[permission]?.[action] || normalizedRole === 'admin' || normalizedRole === 'super_admin';

  if (!roleAllowed || !permissionAllowed) {
    // Role not allowed → redirect to their own dashboard home
    switch (normalizedRole) {
      case 'admin':
      case 'super_admin':
        return <Navigate to="/dashboard/home" replace />;
      case 'staff':
        return <Navigate to="/dashboard/staff-home" replace />;
      case 'student':
        return <Navigate to="/dashboard/student-home" replace />;
      case 'client':
        return <Navigate to="/dashboard/client-support" replace />;
      default:
        return <Navigate to="/dashboard/staff-home" replace />;
    }
  }

  return children;
};

export default RoleProtectedRoute;
